import { atomWithReset } from 'jotai/utils';
import { ClickPosition, ClickPositionPrefix } from '~/utils/click-position';
import { ModuleType } from '~/utils/module-type';

interface AIOverviewInfoModalProps {
  currentPosition: ClickPosition | [ClickPositionPrefix, ClickPosition];
  currentPageModule: ModuleType;
  pageClickId?: string;

  handleClickConfirm?: () => void;

  additionalParams?: Record<string, unknown>;
}

export const $AIOverviewInfoModalShow = atomWithReset<AIOverviewInfoModalProps | false>(false);
